import { Injectable } from '@angular/core';
import { MultisiteService } from '@df/core/service/multisite';
import { Customer } from '@df/session/api/customer';

declare module '@df/session/customer/customer.interfaces' {
    namespace Customer {
        interface ICustomerData {
            isComm?: boolean;
            isTrade?: boolean;
        }
    }
}
export const FORCED_ALLOWED_RETAIL_STORES: { siteId: string; stores: string[] }[] = [{ siteId: 'us', stores: ['us'] }];

@Injectable({
    providedIn: 'root'
})
export class TradeStoreService {
    private isTradeStoreMap = new Map<string, boolean>();

    constructor(
        private multisite: MultisiteService,
        public readonly customer: Customer
    ) {}
    hasTradeMenu(): boolean {
        return this.isTradeStore();
    }

    isTradeStore(site = this.multisite.current): boolean {
        if (!this.isTradeStoreMap.has(site.siteId)) {
            this.isTradeStoreMap.set(site.siteId, site.siteId.toString().includes('trade'));
        }
        return this.isTradeStoreMap.get(site.siteId)!;
    }

    get tradeSites() {
        return this.multisite.all.filter(i => this.isTradeStore(i));
    }
    get retailSites() {
        return this.currentAllowedReatilStores
            ? this.multisite.all.filter(i => !this.isTradeStore(i) && this.currentAllowedReatilStores.includes(i.siteId))
            : this.multisite.all.filter(i => !this.isTradeStore(i));
    }

    get currentAllowedReatilStores(): string[] {
        return FORCED_ALLOWED_RETAIL_STORES.find(s => s.siteId === this.multisite.current.siteId)?.stores;
    }
    isCommerceCustomer(): boolean {
        return !!this.customer.model.data?.isComm;
    }
    isCommerceAllowed(): boolean {
        return !this.isTradeStore() || this.isCommerceCustomer();
    }
    isTradeProspect(): boolean {
        return this.isTradeStore() && !this.isCommerceCustomer() && this.customer.model.isLoggedIn;
    }
}
